import React from 'react';

interface MeteringPointProps {
  eic: string;
  address: string;
  productionCapacity: number;
  withProductionCapacity: boolean;
}

export function MeteringPoint({eic, address, productionCapacity, withProductionCapacity }: MeteringPointProps) {
  return (
    <div
      className="row bg-light rounded px-2 py-3 px-lg-3 mx-0 my-2"
    >
      <div className="col-12 col-lg d-flex flex-row mb-2 mb-lg-0">
        <strong>{eic}</strong>
      </div>
      <div className="col-12 col-lg d-flex flex-row">
        <strong className="text-left">{address}</strong>
      </div>
      {withProductionCapacity && (
        <div className="col-12 col-lg d-flex flex-row">
          <strong className="text-left">{productionCapacity}</strong>
        </div>
      )}
    </div>
  );
}